import { ReactComponent as ArrowLeftFromFile } from '@/assets/images/svg/glyphs/arrow-left.svg';
import type { FC, SVGProps } from 'react';

/**
 * Each glyph’s source file lives under `src/assets/…`. At build time, Next.js runs those `.svg`
 * files through SVGR (`@svgr/webpack`, wired in `src/next-config/webpack.js`) and exposes them as
 * `ReactComponent`. That’s what we want to render whenever it’s available.
 *
 * Storybook is wired through `@storybook/nextjs`, which normally reuses that same webpack setup.
 * In practice, webpack merges and version bumps don’t always match the main app exactly. When SVGR
 * doesn’t run for a given bundle, `ReactComponent` can be `undefined`. Anything that wraps the
 * icon at module load — for example `styled(SomeGlyph)` — then throws an error before your story renders.
 *
 * The inline SVG below mirrors the asset so icons still show up in Storybook (and any other
 * environment where the loader chain differs) instead of taking down the module graph.
 */
const FallbackArrowLeft: FC<SVGProps<SVGSVGElement>> = (props) => (
  <svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg" role="presentation" {...props}>
    <path
      fill="currentColor"
      d="M12.5 15.833 6.667 10 12.5 4.167 11.25 2.917 4.167 10l7.083 7.083 1.25-1.25Z"
    />
  </svg>
);

export const ArrowLeftGlyph: FC<SVGProps<SVGSVGElement>> =
  typeof ArrowLeftFromFile === 'function' ? ArrowLeftFromFile : FallbackArrowLeft;
